var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHyaluronic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.96414 24C4.01594 24 0 19.8 0 14.625C0 11.25 3.51394 5.55 6.45418 1.35C7.02789 0.525 7.96016 0 8.96414 0C9.96813 0 10.9004 0.525 11.5458 1.35C14.4861 5.55 18 11.25 18 14.55C18 19.8 13.9841 24 8.96414 24ZM8.96414 2.25C8.60558 2.25 8.31872 2.4 8.10359 2.7C4.3745 8.175 2.15139 12.45 2.15139 14.625C2.15139 18.6 5.23506 21.75 8.96414 21.75C12.6932 21.75 15.7769 18.525 15.7769 14.625C15.7769 12.525 13.5538 8.175 9.75299 2.7C9.60956 2.4 9.32271 2.25 8.96414 2.25Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyaluronic);
export default __webpack_public_path__ + "static/media/hyaluronic.690014f64f39959079a87be75f656f27.svg";
export { ForwardRef as ReactComponent };